'use client'
import PackageCard from '@/components/LandingPage/PackageCard'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import { IMAGING_TEST_DATA } from '@/helper/DATA'

const HealthScansAndImagingTest = () => {
  return (
    <section id="health-scans" className="container max-w-full py-10 md:py-16 bg-white">
      <div className="flex items-center justify-between mb-8 md:mb-10">
        <h3 className="text-heading-md md:text-heading-lg text-gray-900 mb-1 sm:mb-2">
          Health Scans and Imaging Tests
        </h3>
      </div>

      <div className="relative">
        <Swiper
          slidesPerView="auto"
          spaceBetween={24}
          className="!overflow-visible pb-10"
          modules={[Navigation]}
        >
          {IMAGING_TEST_DATA &&
            IMAGING_TEST_DATA.length > 0 &&
            IMAGING_TEST_DATA.map((item) => {
              return (
                <SwiperSlide key={`imaging${item.id}`} className="!w-auto">
                  <PackageCard data={item} />
                </SwiperSlide>
              )
            })}
        </Swiper>
      </div>
    </section>
  )
}

export default HealthScansAndImagingTest
